let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("iDStG")).then(() => parcelRequire('8aC47'));